const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Public image URL for a customer/supplier brand mark. The backend resolves it from the record's
 * `logo_url` (manual override) or `website` (favicon/manifest chain) and answers 404 when there is none –
 * `CompanyMark` then renders a monogram.
 */
export const brandLogoUrl = (kind, id, version) => (id ? `${API}/brand/${kind}/${id}/logo${version ? `?v=${encodeURIComponent(version)}` : ""}` : null);
